import { render, staticRenderFns } from "./rec-card.vue?vue&type=template&id=6ef01424&scoped=true"
import script from "./rec-card.vue?vue&type=script&lang=js"
export * from "./rec-card.vue?vue&type=script&lang=js"
import style0 from "./rec-card.vue?vue&type=style&index=0&id=6ef01424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef01424",
  null
  
)

export default component.exports